import { Component, OnInit } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { ModalSize, SmartModalService } from '../../services/smart-modal.service';
import { AppService } from '../../shared/services/app.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { BaseService } from '../../shared/services/base.service';
import { StorageService } from '../../shared/services/storage.service';
import { DialogRef } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { PopupFormComponent } from '../popupform/popupform.component';

@Component({
    selector: 'app-select-profile',
    templateUrl: './select-profile.component.html',
    styleUrls: ['./select-profile.component.scss'],
    standalone: false
})
export class SelectProfileComponent implements OnInit {
  config: any = {};

  constructor(
    public baseService: BaseService,
    public appService: AppService,
    public autheticationService: AuthenticationService,
    public storageService: StorageService,
    public alertService: AlertsService,
    public loaderService: LoaderService,
    public smartModalService: SmartModalService,
    public dialogRef: DialogRef,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void {
    // console.log("LALLALA ", this.autheticationService.getCurrentUser());
    this.storageService.getData('LoggedInUser', (res) => {
      this.config.currentUser = res;
    })
    let query_id = 'GET_APPROVED';
    if (this.config.currentUser && this.config.currentUser.extra_data && (this.config.currentUser.extra_data.priOtpLogin || this.config.currentUser.extra_data.otpLogin)) {
      this.baseService.get("GET_CONFIG", "module_code:account-management,config_code:same_mob_no_switch_profile", "facility_config_mapping", "facility-management", "").subscribe(
        res => {
          if (res.errCode == 0 && res.resource.length > 0 && res.resource[0].config_value == 'no') {
            query_id = 'GET_APPROVED';
          }
          else {
            query_id = 'GET_APPROVED_AND_TELECOME';
          }
        }
      )
    }
    this.loaderService.showSpinner();
    setTimeout(() => {
      this.baseService.get(query_id, '', 'user_relationship_mapping', 'account-management').subscribe(data => {
        this.config.currentId = this.autheticationService.getCurrentUser().user_id;
        if (data.errCode == 0 && data.resource && data.resource.length > 0) {
          this.config.data = data.resource;
        }
        this.loaderService.hideSpinner();
      });
    }, 3000);

  }

  changeProfileEvent(data) {
    this.loaderService.showSpinner();
    let loggedUser: any;
    this.storageService.getData('LoggedInUser', (res) => {
      loggedUser = res;
      this.loaderService.hideSpinner();
    })
    let mapId = data.mapped_id ? data.mapped_id : data.user_id;
    this.config.currentId = this.autheticationService.getCurrentUser().user_id;
    if (mapId != this.config.currentId) {
      let obj = {
        'userId': mapId
      }
      this.baseService.action(obj, 'change_user_profile', 'account-management', 'change_profile_event').subscribe(
        (res: any) => {
          if (res.errCode == 0 && res.resource != undefined && res.resource.length) {
            this.loaderService.hideSpinner();
            let object = {
              first_name: data.mapped_name ? data.mapped_name : data.first_name,
              isPasswordExpired: loggedUser.isPasswordExpired,
              login_id: data.login_id,
              user_id: mapId,
              user_type: "patient"
            };
            var uuid = this.appService.getUUID(mapId);
            if (uuid) {
              this.storageService.setData("uuid", uuid, () => { })
            }
            this.storageService.setData('currentUser', object, () => {
              console.log('Logged In User Saved');
              this.autheticationService.currentUserSubject.next(object);
            })
            this.baseService.getById(mapId, 'patient', 'patient-registration').subscribe((respond) => {
              if (respond && respond.uhId) {
                this.loaderService.hideSpinner();
                this.storageService.setData("hasUhId", respond.uhId, () => {
                  console.log("uhid data saved already")
                })
                this.storageService.removeSessionStorageCurrentData() // remove current data from session storage when profile changed
              // }
                this.storageService.setData("patientDetails", res.resource[0], (data) => {
                // console.log("Patient Details data saved alredy")
                // this.appService._currentSessionData.getPatientDetails = data;
                });
                this.storageService.reloadOtherTab();
                this.reloadCurrentPage(mapId)  // refresh window when profile changed
              } else {
                this.storageService.reloadOtherTab();
                this.reloadCurrentPage(mapId)  // refresh window when profile changed
              }
            });
            this.loaderService.hideSpinner();

          } else {
            this.loaderService.hideSpinner();
            this.alertService.error(res.message);
          }
        });
    } else {
      this.loaderService.hideSpinner();
      this.alertService.error("Already the same user profile");
    }
  }

  addMember() {
    this.dialogRef.close();
    let label = {
      "popup": {
        "title": "Add Family Member",
        "size": "lg"
      },
      "title": "Add Family Member",
      "layout_type": "simple",
      "resource": "patient",
      "action": "add",
      "application": "patient-registration",
      "data": {}
    }
    this.dialogService.open(PopupFormComponent, label).afterClosed.subscribe(
      response => {
        console.log("Response is ", response);
        // if(response && response.result && response.result.errCode == 0){
        this.dialogRef.close();
        this.openpopup();
        // }
      });
  }

  openpopup() {
    this.smartModalService.open(SelectProfileComponent, '', 'Manage Your Profiles', ModalSize.Sm, 'center', true).subscribe(res => {
    });
  }

  reloadCurrentPage(userId?: string) {
    const url = new URL(location.href);
    if (!userId) return location.reload();
    if (url.searchParams.has("key") && userId) {
      url.searchParams.set("key", userId); // only use for emr (medical order to see report)
      window.location.href = url.toString();
    }
    else if (/\/patient_profile\/[^/]+\/patient-profile/.test(url.pathname)) // patient profile
      url.pathname = url.pathname.replace(/\/patient_profile\/[^/]+\/patient-profile/, `/patient_profile/${userId}/patient-profile`);
    else return location.reload();
    location.href = url.toString();
  }

}
